var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_18922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92992 3.59888C5.81225 3.64921 4.71599 3.77159 3.64704 3.89523C2.41338 4.03794 1.42677 5.02407 1.2889 6.25827C1.13392 7.64566 0.984375 9.07917 0.984375 10.5458C0.984375 12.0125 1.13392 13.446 1.2889 14.8334C1.42677 16.0675 2.41338 17.0537 3.64703 17.1964C5.04103 17.3576 6.48148 17.5168 7.95528 17.5168C9.42908 17.5168 10.8695 17.3576 12.2635 17.1964C13.4972 17.0537 14.4838 16.0677 14.6217 14.8334C14.7331 13.8354 14.8418 12.8135 14.894 11.7726",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9962 2.17484L8.25845 7.55062L7.6094 10.6033C7.50496 11.0945 8.01697 11.5593 8.49646 11.4085L11.5344 10.4535L16.4279 5.30433C17.2407 4.44912 17.0989 3.01871 16.1151 2.14852C15.1543 1.29872 13.758 1.3105 12.9962 2.17484Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_18922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.283ff0d97b14654385fffa9afb3be4e0.svg";
export { ForwardRef as ReactComponent };